import React from "react";
import Radium from "radium";
import {
  RaisedButton,
  FlatButton,
  Dialog,
  TextField,
  IconMenu,
  MenuItem
} from "material-ui";
import { Link } from "react-router";
import moment from "moment";
import chunk from "lodash/chunk";
import statics from "alt-utils/lib/statics";
import connectToStores from "alt-utils/lib/connectToStores";

import api from "../../utils/api";
import PersonStore from "../../stores/PersonStore";
import EventStore from "../../stores/EventStore";
import BallotStore from "../../stores/BallotStore";
import BallotActions from "../../actions/BallotActions";

import BaseOverlay from "../overlays/base.jsx";

const generateGrid = function (event) {
  function getChunkSize(count) {
    if (count <= 10) {
      return 2;
    } else if (count <= 21) {
      return 3;
    } else {
      return 4;
    }
  }

  let { films } = event;

  // Blocks of 3+ - hide unballoted if same as event name
  if (films.length >= 3) {
    films = films.filter(f =>
      f.name === event.name && f.unballoted ? false : true
    );
  }

  if (films.length <= 2) {
    return films.map(f => [f]);
  }

  let chunkSize = getChunkSize(films.length),
    filmChunks = chunk(films, chunkSize);

  // Transform the film matrix to vertical columns
  // [[1,2],       [[1,4],
  //  [3,4],  ==>   [2,5]
  //  [5]]          [3]]
  let newChunks = new Array(filmChunks.length).fill().map(() => []);
  films.forEach((f, i) => {
    newChunks[i % newChunks.length].push(f);
  });

  return newChunks;
};

export default statics(
  {
    willTransitionTo({ params }, replace, callback) {
      callback();
    }
  },

  (
    @connectToStores
    class BallotingRecord extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          event: null,
          totalsShown: false,
          recording: true,
          submitting: false,
          currentSessionCount: 0,
          currentBallot: {},
          currentBallotNextFilm: null,
          currentBallotReadyToSubmit: false,
          ballotHasBeenSubmitted: false,
          favorite: {}
        };

        this.updateNextFilm = this.updateNextFilm.bind(this);
        this.updateVote = this.updateVote.bind(this);
        this.launch = this.launch.bind(this);
        this.close = this.close.bind(this);
        this.submitBallot = this.submitBallot.bind(this);
        this.parseToken = this.parseToken.bind(this);
        this.handleFavoriteSelection = this.handleFavoriteSelection.bind(this);
      }

      static getStores() {
        return [BallotStore, EventStore];
      }

      static getPropsFromStores() {
        return {
          getDataForOnlineBallot: BallotStore.getDataForOnlineBallot,
          getVotesForEvent: BallotStore.getVotesForEvent,
          getEventById: EventStore.getEventById
        };
      }

      static contextTypes = {
        router: React.PropTypes.object,
        appSettings: React.PropTypes.object
      };

      getStyles() {
        return {
          actions: {
            marginTop: "1.5em"
          },
          count: {
            fontSize: "0.6em",
            color: "rgba(33, 33, 33, 0.6)",
            margin: "-0.5em 0 -1em 0"
          },
          previewBallot: {
            root: {
              display: "table",
              border: 0,
              margin: "1em auto",
              textAlign: "center",
              position: "relative",
              borderCollapse: "collapse",
              width: "90%"
            },
            row: {
              display: "table-row"
            },
            submitting: {
              backgroundColor: "rgba(255,255,255,0.8)",
              display: "block",
              position: "absolute",
              top: 1,
              left: 0,
              right: 0,
              bottom: 0
            },
            entry: {
              border: "1px solid #ccc",
              padding: 20,
              display: "table-cell",
              verticalAlign: "middle"
            },
            name: {
              fontWeight: "bold",
              marginBottom: 5
            },
            ratingBubble: {
              backgroundColor: "rgba(33, 33, 33, 0.6)",
              borderRadius: "100%",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "17pt",
              padding: 5,
              width: 30,
              height: 30,
              lineHeight: "30px",
              display: "inline-block",
              marginLeft: 5,
              cursor: "pointer",
              transition: "0.01s ease-out",
              ":hover": {
                transform: "scale(1.05)"
              }
            },
            ratingBubbleAutoWidth: {
              width: "auto",
              minWidth: 30,
              borderRadius: 10,
              margin: 5
            },
            ratingBubbleSelected: {
              backgroundColor: "rgb(2, 136, 209)"
            },
            ratingButtonContainer: {
              marginLeft: -5
            }
          },
          submit: {
            textAlign: "center"
          }
        };
      }

      parseToken(token) {
        const tokenAscii = atob(token);
        return JSON.parse(tokenAscii);
      }

      handleFavoriteSelection(ticket, val) {
        let favorite = this.state.favorite;
        favorite[ticket] = val.name;
        this.setState({
          favorite: favorite
        });
      }

      submitBallot() {
        if (this.state.submitting) {
          return;
        }

        let { eventId } = this.props;
        if (!eventId) {
          eventId = this.parseToken(this.props.location.query.token).eventId;
        }

        let { currentBallot } = this.state;
        let onlineBallotData = this.props.getDataForOnlineBallot(eventId);
        const films = onlineBallotData.event.films.filter(f => !f.unballoted);
        const pickYourFavorite =
          onlineBallotData.settings.rank_labels_favorite && films.length > 3;

        let favoriteBallot = {};
        if (pickYourFavorite) {
          const keys = Object.keys(currentBallot);
          keys.map(k => {
            const newKey = k + "_" + currentBallot[k].film;
            favoriteBallot[newKey] = currentBallot[k].vote;
          });
        }

        this.setState({ submitting: true });

        api.request(
          {
            method: "POST",
            endpoint: `ballots/record_online_ballot`,
            api_key: PersonStore.getState().token,
            json: {
              event: eventId,
              ballot: pickYourFavorite ? favoriteBallot : currentBallot,
              bulk: false
            }
          },
          (err, d) => {
            if (err) {
              window.alert(err.message);
              this.setState({ submitting: false });
            } else {
              this.setState(
                {
                  currentBallot: {},
                  currentBallotReadyToSubmit: false,
                  currentSessionCount:
                    this.state.currentSessionCount + (d.ballots_recorded || 1),
                  submitting: false,
                  ballotHasBeenSubmitted: true
                },
                () => {
                  this.updateNextFilm();
                }
              );
            }
          }
        );
      }

      updateNextFilm() {
        let { eventId } = this.props;
        if (!eventId) {
          eventId = this.parseToken(this.props.location.query.token).eventId;
        }
        const { currentBallot } = this.state;
        let onlineBallotData = this.props.getDataForOnlineBallot(eventId);
        if (!onlineBallotData) {
          this.setState({ currentBallotNextFilm: null });
          return;
        }
        const tickets = onlineBallotData.tickets;
        const films = onlineBallotData.event.films.filter(f => !f.unballoted);

        if (!tickets.length || !films.length) {
          this.setState({ currentBallotNextFilm: null });
          return;
        }

        // Determine if Record Ballot button can be enabled, including
        // handling the situation where scanning is required and
        // only some tickets are scanned
        const online_balloting_require_ticket_scan =
          this.context.appSettings.online_balloting_require_ticket_scan;
        const pickYourFavorite =
          onlineBallotData.settings.rank_labels_favorite && films.length > 3;

        // calculate total votes that are eligible to be cast currently
        let totalVotes = tickets.length * films.length;
        if (online_balloting_require_ticket_scan) {
          totalVotes = 0;
          tickets.map(t => {
            if (t.used_at && !t.ballot_recorded_at) {
              totalVotes = totalVotes + films.length;
            }
          });
        }

        if (pickYourFavorite) {
          totalVotes = tickets.length;
          for (let x = 0; x < tickets.length; x++) {
            if (!currentBallot[tickets[x]._id]) {
              this.setState({
                currentBallotReadyToSubmit:
                  totalVotes === 0
                    ? false
                    : Object.values(currentBallot).length === totalVotes
              });
              return;
            }
          }
        } else {
          for (let x = 0; x < tickets.length; x++) {
            const ticket_used_at = tickets[x].used_at;
            for (let i = 0; i < films.length; i++) {
              if (!currentBallot[tickets[x]._id + "_" + films[i]._id]) {
                this.setState({
                  currentBallotNextFilm: tickets[x]._id + "_" + films[i]._id,
                  currentBallotReadyToSubmit:
                    totalVotes === 0
                      ? false
                      : Object.values(currentBallot).length === totalVotes
                });
                return;
              }
            }
          }
        }

        // leave the pointer at the previous entry
        this.setState({ currentBallotReadyToSubmit: true });
      }

      updateVote(id, vote) {
        let { currentBallot } = this.state;
        currentBallot[id] = vote;
        this.setState({ currentBallot }, () => {
          this.updateNextFilm();
        });
      }

      updateFavoriteVote(id, vote) {
        let { currentBallot } = this.state;
        const ticketId = id.substring(0, id.indexOf("_"));
        const filmId = id.substring(id.indexOf("_") + 1);
        currentBallot[ticketId] = { film: filmId, vote: vote };
        this.setState({ currentBallot }, () => {
          this.updateNextFilm();
        });
      }

      launch() {
        if (this.state.recording) {
          return;
        } // already launched
        this.setState(
          {
            currentSessionCount: 0,
            currentBallot: {},
            currentBallotReadyToSubmit: false,
            recording: true
          },
          () => {
            this.updateNextFilm();
          }
        );
      }

      close() {
        this.setState({ recording: false });
        if (this.props.onClose) {
          this.props.onClose();
        } else {
          if (this.props.location.query.token) {
            this.context.router.push("/welcome");
          }
        }
      }

      componentWillMount() {
        // if eventId is not a prop, check this.props.location for the query string
        let { eventId, tickets } = this.props;
        if (!eventId) {
          const queryItems = this.parseToken(this.props.location.query.token);
          eventId = queryItems.eventId;
          tickets = queryItems.tickets;
        }
        BallotActions.fetchOnlineBallotData.defer(eventId, tickets);
        this.componentWillReceiveProps(this.props);
      }

      componentWillReceiveProps(props) {
        if (this.state.recording && !this.state.submitting) {
          this.setState({
            currentBallot: props.getVotesForEvent(props.event) || {}
          });
        }

        if (this.props.eventId !== props.eventId) {
          let { eventId, tickets } = props;
          if (!eventId) {
            const queryItems = this.parseToken(props.location.query.token);
            eventId = queryItems.eventId;
            tickets = queryItems.tickets;
          }
          BallotActions.fetchOnlineBallotData.defer(eventId, tickets);
        }
      }

      componentWillUnmount() {
        this.close();
      }

      render() {
        let { eventId, tickets } = this.props;
        const online_balloting_require_ticket_scan =
          this.context.appSettings.online_balloting_require_ticket_scan;
        const online_balloting_voting_enabled =
          this.context.appSettings.online_balloting_voting_enabled;

        const LEVEL_LABELS = [
          "Excellent",
          "Great",
          "Average",
          "Below Average",
          "Not Good"
        ];

        // if eventId is not a prop, check this.props.location for the query string
        if (!eventId) {
          const queryItems = this.parseToken(this.props.location.query.token);
          eventId = queryItems.eventId;
          tickets = queryItems.tickets;
        }

        let onlineBallotData = this.props.getDataForOnlineBallot(eventId),
          { submitting } = this.state,
          styles = this.getStyles(),
          isReversed = false;

        if (!onlineBallotData) {
          return <div></div>;
        }

        let event = onlineBallotData.event;
        if (!event) {
          return <div></div>;
        }

        let ticketList = onlineBallotData.tickets;

        let eventBucket = event.event_bucket;

        let labels = onlineBallotData.settings.rank_labels
          .split(",")
          .map(l => l.trim());

        const isUpDown = onlineBallotData.settings.design === "updown";
        let levels = isUpDown
          ? ["+", "-"]
          : onlineBallotData.settings.rank_labels.split(",").map(l => l.trim());
        let levelsKeyed = levels.map((l, i) => ({
          level: l,
          key: LEVEL_LABELS[
            i > Math.floor(levels.length / 2)
              ? LEVEL_LABELS.length - (levels.length - i)
              : i
          ]
        }));

        // numeric = worst->best
        if (labels.some(l => +l === 1)) {
          isReversed = true;
          labels.reverse();
        }

        const pickYourFavorite =
          onlineBallotData.settings.rank_labels_favorite &&
          event.films.length > 3;
        const favorite = this.state.favorite;

        const useAutoWidthBubbles = labels.some(l => l.length > 3);

        let hasCustomTagHeader = false;
        let tagCheckList = event.new_tags || [];
        let firstFoundTag = null;
        for (let f = 0; f < event.films.length; f++) {
          tagCheckList = tagCheckList.concat(event.films[f].tags || []);
        }

        if (
          tagCheckList.length > 0 &&
          this.context.appSettings
            .online_balloting_custom_introduction_by_tagging
        ) {
          for (
            let tc = 0;
            tc <
            this.context.appSettings.online_ballot_custom_introduction_tags
              .length;
            tc++
          ) {
            const introTag =
              this.context.appSettings.online_ballot_custom_introduction_tags[
                tc
              ];
            for (let cl = 0; cl < tagCheckList.length; cl++) {
              const checkTag = tagCheckList[cl];
              if (introTag === checkTag) {
                hasCustomTagHeader = true;
                firstFoundTag = introTag;
                break;
              }
            }
            if (hasCustomTagHeader) {
              break;
            }
          }
        }

        return (
          <div>
            <BaseOverlay
              useMuiDefaultStyle={true}
              title={
                <div>
                  {event &&
                    `${event.name} – ${moment(event.start_time).format("lll")}`}
                </div>
              }
              modal={true}
              open={this.state.recording}
              actions={[
                <FlatButton
                  label="Close ballot entry"
                  primary={false}
                  onClick={this.close}
                />
              ]}
            >
              {!online_balloting_voting_enabled ? (
                <div>Voting has been closed.</div>
              ) : this.state.ballotHasBeenSubmitted ? (
                <div>Your ballot has been successfully submitted.</div>
              ) : event ? (
                <div>
                  <div
                    style={{
                      textAlign: "center",
                      paddingTop: 10,
                      paddingBottom: 10
                    }}
                    dangerouslySetInnerHTML={{
                      __html: hasCustomTagHeader
                        ? this.context.appSettings
                            .online_ballot_custom_introduction_by_tagging_modal_headers[
                            firstFoundTag
                          ]
                        : this.context.appSettings.online_ballot_modal_header
                        ? this.context.appSettings.online_ballot_modal_header
                        : null
                    }}
                  ></div>
                  {levels.length > 3 ? (
                    <div
                      style={{
                        textAlign: "center",
                        paddingTop: 0,
                        paddingBottom: 10,
                        fontSize: 13,
                        lineHeight: "14px"
                      }}
                    >
                      {levelsKeyed.map(lvl => (
                        <span>
                          <span style={{ whiteSpace: "nowrap" }}>
                            {lvl.level} = {lvl.key}
                          </span>{" "}
                          &nbsp;&nbsp;&nbsp;
                        </span>
                      ))}
                    </div>
                  ) : null}
                  {ticketList.map((t, i) => (
                    <div style={styles.previewBallot.root}>
                      <div
                        style={{
                          display: "table-caption",
                          marginBottom: 3,
                          fontWeight: "bold"
                        }}
                      >
                        {t.pass
                          ? "Ticket #" + (i + 1) + ": " + t.pass.name
                          : "Ticket #" + (i + 1)}
                      </div>
                      {event.films.length === 0 ? (
                        <div style={styles.previewBallot.row} key={"none"}>
                          <div style={styles.previewBallot.entry}>
                            <div style={{ fontStyle: "italic" }}>
                              No balloted films to vote on
                            </div>
                          </div>
                        </div>
                      ) : t.ballot_recorded_at ? (
                        <div>This ballot has already been cast.</div>
                      ) : online_balloting_require_ticket_scan && !t.used_at ? (
                        <div>
                          This ticket has not been scanned. It must be scanned
                          before you can cast your ballot.
                        </div>
                      ) : pickYourFavorite ? (
                        <div style={{ textAlign: "center " }}>
                          <IconMenu
                            iconButtonElement={
                              <FlatButton
                                primary={true}
                                label={
                                  favorite[t._id] ? (
                                    <span>
                                      <span className="text-gray-400">
                                        Your favorite:
                                      </span>{" "}
                                      {favorite[t._id]}
                                    </span>
                                  ) : (
                                    "Select your favorite film"
                                  )
                                }
                                style={{
                                  border: "1px solid",
                                  marginBottom: 20,
                                  lineHeight: "30px"
                                }}
                              />
                            }
                            menuStyle={styles.menu}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right"
                            }}
                            targetOrigin={{
                              vertical: "top",
                              horizontal: "right"
                            }}
                          >
                            {event.films.map(option => {
                              return (
                                <MenuItem
                                  key={t._id + "_" + option._id}
                                  onClick={v => {
                                    this.handleFavoriteSelection(t._id, option);
                                    this.updateFavoriteVote(
                                      t._id + "_" + option._id,
                                      5
                                    );
                                  }}
                                  primaryText={option.name}
                                />
                              );
                            })}
                          </IconMenu>
                        </div>
                      ) : (
                        generateGrid(event).map(row => {
                          return (
                            <div style={styles.previewBallot.row}>
                              {row.map(f => {
                                return (
                                  <div
                                    key={t._id + "_" + f._id}
                                    style={styles.previewBallot.entry}
                                  >
                                    <div style={styles.previewBallot.name}>
                                      {f.name}
                                    </div>
                                    {f.unballoted ? (
                                      <div>
                                        <i>Not in competition</i>
                                      </div>
                                    ) : (
                                      <div>
                                        <div
                                          style={
                                            styles.previewBallot
                                              .ratingButtonContainer
                                          }
                                        >
                                          {labels.map((l, i) => {
                                            // In the case where there is only a single label, just use whatever key is
                                            // on the ballot. This is necessary for cases where the vote keys have gotten
                                            // out of sync and a single item => 5, for example SIGGRAPH 2021.
                                            // E.g. given label=["star"], ballot[film] = { 5: 27 }, grabs [5] as the possible vote.
                                            // Ref: https://eventiveteam.slack.com/archives/C01DQN0LV9C/p1628775299002200
                                            const singleBallotWorkaround =
                                              labels.length === 1 &&
                                              this.state.currentBallot[
                                                t._id + "_" + f._id
                                              ] &&
                                              Object.keys(
                                                this.state.currentBallot[
                                                  t._id + "_" + f._id
                                                ]
                                              );

                                            const vote =
                                              singleBallotWorkaround &&
                                              singleBallotWorkaround.length ===
                                                1
                                                ? singleBallotWorkaround[0]
                                                : isReversed
                                                ? labels.length - i
                                                : i + 1;

                                            return (
                                              <div
                                                key={`${t._id}_${f._id}-${l}`}
                                                style={Object.assign(
                                                  {},
                                                  styles.previewBallot
                                                    .ratingBubble,
                                                  useAutoWidthBubbles &&
                                                    styles.previewBallot
                                                      .ratingBubbleAutoWidth,
                                                  this.state.currentBallot[
                                                    t._id + "_" + f._id
                                                  ] === vote &&
                                                    styles.previewBallot
                                                      .ratingBubbleSelected
                                                )}
                                                onClick={() => {
                                                  this.updateVote(
                                                    t._id + "_" + f._id,
                                                    vote
                                                  );
                                                }}
                                              >
                                                {l}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })
                      )}
                      {submitting && (
                        <div style={styles.previewBallot.submitting} />
                      )}
                    </div>
                  ))}
                  <div style={styles.submit}>
                    <RaisedButton
                      primary
                      label={
                        this.state.submitting
                          ? "Recording ballot..."
                          : "Record ballot"
                      }
                      disabled={
                        this.state.submitting ||
                        !this.state.currentBallotReadyToSubmit
                      }
                      onClick={this.submitBallot}
                    />
                  </div>
                </div>
              ) : null}
            </BaseOverlay>
          </div>
        );
      }
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/components/partials/balloting-record.jsx